import { render, staticRenderFns } from "./MessageReply.vue?vue&type=template&id=32d41f3e&scoped=true&"
import script from "./MessageReply.vue?vue&type=script&lang=js&"
export * from "./MessageReply.vue?vue&type=script&lang=js&"
import style0 from "./MessageReply.vue?vue&type=style&index=0&id=32d41f3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d41f3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
